import React, { useState } from 'react';

const ButtonSquad = ({ icon: Icon, texto, onClick, isMobile, gradient, desabilitado, badge }) => {
  const [isHovered, setIsHovered] = useState(false);

  if (desabilitado) {
    return (
      <button 
        disabled
        style={{
          ...styles.card,
          background: gradient,
          cursor: 'not-allowed',
          opacity: 0.8
        }}
      >
        <div style={{
          ...styles.iconContainer,
          backgroundColor: 'rgba(255, 255, 255, 0.2)',
        }}>
          <Icon size={isMobile ? 24 : 28} color="#FFFFFF" />
        </div>
        <span style={styles.label}>{texto}</span>
        <span style={{ color: '#FF0000', fontSize: '12px', fontWeight: '700', marginTop: '4px' }}>EM BREVE</span>
      </button>
    );
  }

  return (
    <button 
      onClick={onClick} 
      style={{
        ...styles.card,
        background: gradient,
        ...(isHovered && styles.cardHover)
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div style={{
        ...styles.iconContainer,
        backgroundColor: 'rgba(255, 255, 255, 0.2)',
        ...(isHovered && styles.iconContainerHover)
      }}>
        <Icon size={isMobile ? 24 : 28} color="#FFFFFF" />
      </div>
      <span style={styles.label}>{texto}</span>
      {badge > 0 && (
        <span style={{ position: 'absolute', top: '10px', right: '10px', background: '#e74c3c', color: 'white', borderRadius: '10px', padding: '4px 10px', fontSize: '14px', fontWeight: 'bold', minWidth: '24px', textAlign: 'center', boxShadow: '0 2px 4px rgba(0,0,0,0.3)' }}>{badge > 99 ? '99+' : badge}</span>
      )}
    </button>
  );
};

const styles = {
  card: {
    position: 'relative',
    border: 'none',
    borderRadius: '16px',
    padding: '25px 15px',
    fontFamily: 'Montserrat, sans-serif',
    fontSize: '16px',
    fontWeight: '600',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '140px',
    cursor: 'pointer',
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    position: 'relative',
    overflow: 'hidden',
  },
  cardHover: {
    transform: 'translateY(-5px)',
    boxShadow: '0 8px 35px rgba(0, 0, 0, 0.25)',
    filter: 'brightness(1.1)',
  },
  iconContainer: {
    marginBottom: '12px',
    padding: '15px',
    borderRadius: '12px',
    transition: 'all 0.3s ease',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  iconContainerHover: {
    backgroundColor: 'rgba(255, 255, 255, 0.3)',
    transform: 'scale(1.1)',
  },
  label: {
    marginTop: '8px',
    textAlign: 'center',
    lineHeight: '1.3',
    fontSize: '14px',
    fontWeight: '600',
    fontFamily: 'Montserrat, sans-serif',
    color: '#FFFFFF',
  }
};

export default ButtonSquad;